import { render } from "./ImobiliariasView.vue?vue&type=template&id=1608b086&scoped=true"
import script from "./ImobiliariasView.vue?vue&type=script&lang=js"
export * from "./ImobiliariasView.vue?vue&type=script&lang=js"

import "./ImobiliariasView.vue?vue&type=style&index=0&id=1608b086&scoped=true&lang=css"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1608b086"]])

export default __exports__